import AlertManager from './AlertManager';
export * from './AlertBox';

export default AlertManager;
